import React, { useContext, useEffect } from "react";
import {
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverArrow,
  IconButton,
  Text,
  Box,
  HStack,
  Stack,
  Tooltip,
  Skeleton,
} from "@chakra-ui/react";
import { MdOutlineDrafts, MdOutlineMarkEmailRead } from "react-icons/md";
import { putNotificacionesII } from "../../config/helpers/api.helper";
/* import { useNavigate } from "react-router-dom"; */
import { ReactComponent as Bell } from "../../../assets/iconos/notifications_FILL0.svg";
import moment from "moment";
import { NotificationsContext } from "../../../contexts/notificationContext";
import { useSelector } from "react-redux";
import NotificationCard from "./NotificationCard";
// import { putUsuarios } from "../../usuarios/helpers/api.helper";
// import { userNotiActiva } from "../../../redux/actions/action.user";

const Notificationes = (props) => {
  const { loading } = props;
  const {
    notificaciones,
    setNotificaciones,
    notificacionGlobalActivas,
    setNotificacionGlobalActivas,
  } = useContext(NotificationsContext);
  const { user } = useSelector((state) => state.user);
  const [loadingReadAllNotifications, setLoadingReadAllNotifications] =
    React.useState(false);
  // const dispatch = useDispatch();
  const notificacionesSinLeer = notificaciones?.filter(
    (e) => e.leidoNBS === false
  );
  const isAllNotiRead = notificaciones.every((e) => e.leidoNBS === true);
  console.log("isAllNotiRead", isAllNotiRead);

  const handleLeido = async (element) => {
    if (user.idRol === "usuarioIT") {
      const editar = notificaciones.map((item) => {
        if (item.idNotificacionesBS === element.idNotificacionesBS) {
          return {
            ...item,
            leidoNBS: !element.leidoNBS,
          };
        }
        return item;
      });

      setNotificaciones(editar);
    } else {
      let data = {
        id: element.idNotificacionesBS,
        leidoNBS: !element.leidoNBS,
      };
      let res = await putNotificacionesII({ leido: [data] });

      if (res.status === 200) {
        const editar = notificaciones.map((item) => {
          if (item.idNotificacionesBS === element.idNotificacionesBS) {
            return {
              ...item,
              leidoNBS: !element.leidoNBS,
            };
          }
          return item;
        });
        console.log("editar", editar);
        setNotificaciones(editar);
      }
    }
  };

  const handleAllAsRead = async () => {
    setLoadingReadAllNotifications(true);
    let data = notificaciones.map((element) => {
      console.log(element);
      return {
        id: element.idNotificacionesBS,
        leidoNBS: isAllNotiRead ? false : true,
      };
    });
    try {
      let res = await putNotificacionesII({ leido: data });
      if (res.status === 200) {
        const editar = notificaciones.map((item) => {
          return {
            ...item,
            leidoNBS: isAllNotiRead ? false : true,
          };
        });
        setNotificaciones(editar);
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingReadAllNotifications(false);
    }
  };

  const handleGlobalActivas = async () => {
    if (user.notificacionGlobalActivas === true) {
      setNotificacionGlobalActivas(false);
    }
  };

  const obtenerTextoAntesDelPunto = (texto) => {
    // Buscar la posición del primer punto en el texto
    const posicionPunto = texto.indexOf(".");

    // Si no se encuentra un punto, devolver el texto completo
    if (posicionPunto === -1) {
      return texto;
    }

    // Devolver todo el texto antes del primer punto
    return texto.substring(0, posicionPunto);
  };

  useEffect(() => {}, [notificacionesSinLeer.length]);

  return (
    !loading && (
      <Popover placement="bottom-end">
        <PopoverTrigger>
          <Box position={"relative"} display={"inline-block"}>
            <IconButton
              bg="gray.300"
              borderRadius="50%"
              name="notificaciones"
              onClick={() => handleGlobalActivas()}
            >
              <Box>
                <Bell />
              </Box>
            </IconButton>
            {notificaciones?.length > 0 &&
              notificacionGlobalActivas === true &&
              notificaciones?.some((e) => e.leidoNBS === false) && (
                <Box
                  position="absolute"
                  top="1px"
                  right="-7px"
                  bg="#B21515"
                  color="white"
                  borderRadius="50%"
                  placeContent={"center"}
                  width="20px"
                  height="20px"
                  display="flex"
                  fontWeight={"light"}
                  fontSize="12px"
                  zIndex={10}
                >
                  <Text>
                    {notificaciones.filter((e) => e.leidoNBS === false).length <
                    99
                      ? notificaciones.filter((e) => e.leidoNBS === false)
                          .length
                      : "+99"}
                  </Text>
                </Box>
              )}
          </Box>
        </PopoverTrigger>
        <PopoverContent>
          <PopoverArrow />
          <PopoverHeader letterSpacing={1}>
            <HStack w={"100%"} justifyContent={"space-between"}>
              <Text>
                Notificaciones{" "}
                {`(${
                  notificaciones.filter((e) => e.leidoNBS === false).length
                })`}
              </Text>
              <Tooltip
                label={
                  isAllNotiRead
                    ? "Marcar todos como no leídos"
                    : "Marcar todos como leídos"
                }
              >
                <IconButton
                  variant={"link"}
                  icon={
                    isAllNotiRead ? (
                      <MdOutlineMarkEmailRead />
                    ) : (
                      <MdOutlineDrafts />
                    )
                  }
                  onClick={handleAllAsRead}
                  cursor={"pointer"}
                />
              </Tooltip>
            </HStack>
          </PopoverHeader>
          <PopoverBody>
            <Stack overflow={"auto"} maxH={"xs"}>
              {loadingReadAllNotifications
                ? notificaciones.map((elem, index) => (
                    <Skeleton
                      key={elem.idNotificacionesBS * index}
                      height={"20px"}
                      spacing="3"
                    />
                  ))
                : notificaciones
                    .sort(
                      (a, b) =>
                        moment(b.fechaCreacionNBS).valueOf() -
                        moment(a.fechaCreacionNBS).valueOf()
                    )
                    .map((elem, index) => (
                      <NotificationCard
                        key={index}
                        elem={elem}
                        handleLeido={handleLeido}
                        obtenerTextoAntesDelPunto={obtenerTextoAntesDelPunto}
                      />
                      // <Card
                      //   key={index}
                      //   size={"sm"}
                      //   variant="unstyled"
                      //   bg={
                      //     elem.leidoNBS === false
                      //       ? "brand.fondos_secundarios"
                      //       : "white"
                      //   }
                      //   p={2}
                      // >
                      //   <CardHeader>
                      //     <HStack
                      //       justifyContent={"space-between"}
                      //       borderRadius={5}
                      //     >
                      //       <Heading
                      //         size={"md"}
                      //         fontWeight={"semibold"}
                      //         color={"gray.600"}
                      //         textAlign={"left"}
                      //       >
                      //         {elem.tituloNBS}
                      //       </Heading>
                      //       <Tooltip
                      //         label={
                      //           elem.leidoNBS === false
                      //             ? "Marcar como leído"
                      //             : "Marcar como no leído"
                      //         }
                      //       >
                      //         <IconButton
                      //           variant={"link"}
                      //           onClick={() => handleLeido(elem)}
                      //           cursor={"pointer"}
                      //           icon={
                      //             elem.leidoNBS === false ? (
                      //               <MdOutlineMarkunread />
                      //             ) : (
                      //               <MdOutlineDrafts />
                      //             )
                      //           }
                      //         />
                      //       </Tooltip>
                      //     </HStack>
                      //   </CardHeader>
                      //   {/*  onClick={() => openModal(elem)} */}
                      //   <CardBody>
                      //     <Heading
                      //       size={"sm"}
                      //       color={"gray"}
                      //       fontWeight={"normal"}
                      //     >
                      //       {`${obtenerTextoAntesDelPunto(
                      //         elem.descripciónNBS
                      //       )}.`}
                      //     </Heading>
                      //   </CardBody>
                      //   <CardFooter
                      //     w={"100%"}
                      //     size={"sm"}
                      //     color={"gray"}
                      //     fontWeight={"normal"}
                      //     justifyContent={"end"}
                      //   >
                      //     {moment(elem.fechaCreacionNBS).format(
                      //       "DD/MM/YYYY HH:mm:ss"
                      //     )}
                      //   </CardFooter>
                      // </Card>
                    ))}
            </Stack>
          </PopoverBody>
        </PopoverContent>
      </Popover>
    )
  );
};

export default Notificationes;
